import React, { useState } from "react";
import {
  FormControl,
  Typography,
  MenuItem,
  Select,
  Button
} from "@material-ui/core";
import BusinessIcon from "@material-ui/icons/Business";
import Cookies from "js-cookie";
import clsx from "clsx";
import { useTranslation } from "../../langs/useTranslation";
import CompanyTreeDialog from "../deviceControl/CompanyTreeDialog";
import useStyles from "../../styles/deviceControlStyle";
import { getCompanyTreeApi } from "../../apis/getCompanyTreeApi";

const SelectType = props => {
  const {
    groupId,
    setGroupId,
    setSelectType,
    selectType,
    setSelectCompanyName,
    selectCompanyName,
    setSelectCompany,
    selectCompany,
    groups,
    noGroup,
    noTag,
    allTags,
    tagId,
    setTagId,
    companyIdFirst,
    companyNameFirst
  } = props;
  const classes = useStyles();
  const { t } = useTranslation("deviceControl");
  const [loading, setLoading] = useState(false);
  const [showTree, setShowTree] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [tempData, setTempData] = useState({});

  const typeHandler = () => {
    switch (selectType) {
      case "company":
        return (
          <>
            <div className={classes.selectType}>
              <Typography className={classes.selectText} variant="body1">
                {t("common.selectCompany")}
              </Typography>
              <div className={classes.uploadArea}>
                <Button
                  variant="outlined"
                  component="label"
                  className={classes.selectCompanyBtn}
                  onClick={handleSelectCompany}
                >
                  {selectCompanyName
                    ? selectCompanyName
                    : `${t("common.selectCompany")}`}
                  <BusinessIcon />
                </Button>
              </div>
            </div>
          </>
        );
      case "group":
        return (
          <>
            <div className={classes.selectType}>
              <Typography
                className={`${classes.selectText} ${classes.selectGroupText}`}
                variant="body1"
              >
                {t("common.selectDeviceGroup")}
              </Typography>

              <FormControl>
                <Select
                  variant="outlined"
                  value={groupId}
                  onChange={handleChangeGroups}
                  disabled={loading}
                  placeholder={t("common.selectDeviceGroup")}
                  className={clsx(classes.select, classes.selectSm)}
                  MenuProps={{
                    disableScrollLock: true,
                    classes: { paper: classes.menuPaper }
                  }}
                >
                  {groups?.length > 0 ? (
                    groups.map(e => {
                      return (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem disabled>No options</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
          </>
        );
      case "tag":
        return (
          <>
            <div className={classes.selectType}>
              <Typography
                className={`${classes.selectText} ${classes.selectGroupText}`}
                variant="body1"
              >
                {t("common.selectDeviceTag")}
              </Typography>

              <FormControl>
                <Select
                  variant="outlined"
                  value={tagId}
                  onChange={handleChangeTags}
                  disabled={loading}
                  placeholder={t("common.selectDeviceTag")}
                  className={clsx(classes.select, classes.selectSm)}
                  MenuProps={{
                    disableScrollLock: true,
                    classes: { paper: classes.menuPaper }
                  }}
                >
                  {allTags?.length > 0 ? (
                    allTags.map(e => {
                      return (
                        <MenuItem key={e.id} value={e.id}>
                          {e.name}
                        </MenuItem>
                      );
                    })
                  ) : (
                    <MenuItem disabled>No options</MenuItem>
                  )}
                </Select>
              </FormControl>
            </div>
          </>
        );
      default:
        break;
    }
  };

  const handleChangeTags = async e => {
    setLoading(true);
    setTagId(e.target.value);
    Cookies.set("select_tag", e.target.value);
    setLoading(false);
    e.persist();
  };

  const handleChangeGroups = async e => {
    setLoading(true);
    setGroupId(e.target.value);
    Cookies.set("select_group", e.target.value);
    setLoading(false);
    e.persist();
  };

  const handleChangeType = async e => {
    setLoading(true);
    const type = e.target.value;
    setSelectType(type);
    if (type === "group") {
      setGroupId(groups[0].id);
      Cookies.set("select_group", groups[0].id);
    }
    if (type === "tag") {
      setTagId(allTags[0].id);
      Cookies.set("select_tag", allTags[0].id);
    }
    if (type === "company") {
      setSelectCompany(companyIdFirst);
      setSelectCompanyName(companyNameFirst);
      Cookies.set(
        "select_company",
        JSON.stringify({
          companyId: companyIdFirst,
          companyName: companyNameFirst
        })
      );
    }
    Cookies.set("select_type", type);

    setLoading(false);
  };

  const handleSelectCompany = () => {
    setShowTree(true);
  };

  const onCloseCompany = async (close = false, tempData) => {
    if (!close) {
      setLoading(true);
      setLoading(false);
    }
    setSearchValue("");
    setShowTree(false);
  };

  return (
    <>
      <div>
        <div className={classes.selectTypeArea}>
          <div className={classes.selectType}>
            <Typography className={classes.selectText} variant="body1">
              {t("common.selectType")}
            </Typography>

            <FormControl>
              <Select
                variant="outlined"
                value={selectType}
                onChange={handleChangeType}
                disabled={loading}
                placeholder={t("common.selectType")}
                className={classes.selectSm}
                MenuProps={{
                  disableScrollLock: true
                }}
              >
                <MenuItem value="company">Companies</MenuItem>
                <MenuItem value="group">Groups</MenuItem>
                <MenuItem value="tag">Tags</MenuItem>
              </Select>
            </FormControl>
          </div>
          {typeHandler()}
        </div>
        {selectType === "group" && noGroup && (
          <Typography
            variant="body2"
            color="error"
            className={classes.noGroupText}
            style={{ marginTop: "15px" }}
          >
            {t("noty.noGroup")}
          </Typography>
        )}
        {selectType === "tag" && noTag && (
          <Typography
            variant="body2"
            color="error"
            className={classes.noGroupText}
            style={{ marginTop: "15px" }}
          >
            {t("noty.noTag")}
          </Typography>
        )}
      </div>
      <CompanyTreeDialog
        open={showTree}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        tempData={tempData}
        setTempData={setTempData}
        onClose={onCloseCompany}
        setSelectCompany={setSelectCompany}
        selectCompany={selectCompany}
        selectCompanyName={selectCompanyName}
        setSelectCompanyName={setSelectCompanyName}
        dataLoader={getCompanyTreeApi}
      />
    </>
  );
};

export default SelectType;
